<template>
	<div class="popup">
		<ManagingSection class="search-by-enter__container">
			<ManagingBox title="팝업배너명">
				<input
					class="search-by-enter__target"
					v-model="searchWord"
					type="text"
				/>
			</ManagingBox>
		</ManagingSection>
		<div class="btn-wrap-main">
			<button class="btn-main blue" type="button" @click="getSearch">
				검색
			</button>
			<button
				class="btn-main blue bordered"
				type="button"
				@click="initSearch"
			>
				검색조건 초기화
			</button>
		</div>
		<ManagingSection :isTable="true">
			<template slot="infoSection">
				<div class="section__info__left popup__list__summary">
					검색결과: 전체 {{ total }} 건 (노출 {{ displayTotal }}건 /
					미노출 {{ noDisplayTotal }}건)
				</div>
			</template>
			<table class="table-main">
				<thead>
					<tr>
						<th>번호</th>
						<th>등록일</th>
						<th>팝업배너명</th>
						<th>시작일시</th>
						<th>종료일시</th>
						<th>노출수</th>
						<th>클릭수</th>
						<th>상태</th>
						<th>순서</th>
						<th>관리자명</th>
						<th>삭제</th>
					</tr>
				</thead>
				<tbody>
					<tr
						:class="{ 'popup__list__table--exp': item.status }"
						v-for="item in list"
						:key="item.idPopup"
					>
						<td>{{ item.idPopup }}</td>
						<td>{{ item.createdDate }}</td>
						<td>
							<router-link
								class="popup__list__table__title"
								:to="`/manage/init-popup/modify/${item.idPopup}`"
								>{{ item.popupTitle }}</router-link
							>
						</td>
						<td>{{ item.startDate }}</td>
						<td>{{ item.endDate || '-' }}</td>
						<td>{{ item.showCount }}</td>
						<td>{{ item.clickCount }}</td>
						<td>{{ item.status ? '노출' : '미노출' }}</td>
						<td>
							<input
								type="number"
								aria-label="순서"
								class="popup__list__table__sort"
								min="0"
								v-model.number="item.sort"
							/>
							<button
								class="btn popup__list__table__sort-change"
								@click="changeSort(item)"
							>
								변경
							</button>
						</td>
						<td>{{ item.adminName }}</td>
						<td>
							<button
								@click="remove(item.idPopup)"
								class="btn-delete"
							>
								삭제
							</button>
						</td>
					</tr>
				</tbody>
			</table>
			<PaginationBox
				slot="pagination"
				:totalItem="getTotal"
				:offset="getCursor"
				:limit="limit"
				:pageLengPerOne="pageGroupLimit"
				@to="paging"
			/>
		</ManagingSection>
	</div>
</template>
<script>
	import { getIdRegister } from '@/util';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import SearchByEnter from '@/components/extends/SearchByEnter.vue';
	import PaginationBox from '@/components/PaginationBox';

	export default {
		name: 'InitPopup',
		components: {
			ManagingSection,
			ManagingBox,
			PaginationBox,
			SearchByEnter,
		},
		extends: SearchByEnter,
		data() {
			return {
				total: 0,
				displayTotal: 0,
				noDisplayTotal: 0,
				cursor: 0,
				limit: 50,
				pageGroupLimit: 10,
				list: [],
				searchWord: '',
			};
		},
		mounted() {
			this.getList();
		},
		computed: {
			getTotal() {
				return this.total;
			},
			getCursor() {
				return this.cursor;
			},
		},
		methods: {
			paging(args) {
				this.cursor = args.offset;
				this.getList(this.searchWord);
			},
			getList(search = '') {
				this.$store.commit('toggleSpinner', true);

				this.$axiosAdmin2
					.get(
						`/api/popup/list?currentPage=${this.cursor / this.limit + 1}&itemSize=${this.limit}&popupTitle=${encodeURIComponent(search)}`
					)
					.then(({ data }) => {
						this.total = data.popupStatistics.total;
						this.displayTotal = data.popupStatistics.displayTotal;
						this.noDisplayTotal =
							data.popupStatistics.noDisplayTotal;

						this.list = [
							...data.result.resultList
								.filter(item => item.status)
								.sort((a, b) => a.sort - b.sort),
							...data.result.resultList.filter(
								item => !item.status
							),
						];
						this.$store.commit('toggleSpinner', false);
					})
					.catch(({ response }) => {
						console.error(response);
						this.$store.commit('toggleSpinner', false);
					});
			},
			remove(idPopup) {
				if (confirm('정말 삭제하시겠습니까?')) {
					this.$axiosAdmin2
						.delete(`/api/popup/${idPopup}`)
						.then(({ data }) => {
							this.getList(this.searchWord);
						})
						.catch(({ response }) => {
							console.error(response);
							alert('서버와의 통신중 오류가 발생했습니다.');
						});
				}
			},
			getSearch() {
				if (this.searchWord.trim().length === 0) {
					alert('검색어를 입력해주세요');
				} else {
					this.cursor = 0;
					this.getList(this.searchWord);
				}
			},
			initSearch() {
				this.searchWord = '';
				this.getList();
			},
			async changeSort(item) {
				const getTime = string => {
					const timestamp = new Date(string).getTime();

					return !isNaN(timestamp) ? timestamp : null;
				};

				try {
					const { data } = await this.$axiosAdmin2.get(
						`/api/popup/${item.idPopup}`
					);

					const params = {
						idRegister: getIdRegister(),
						idPopup: item.idPopup,
						popupTitle: data.popupTitle,
						startDate: getTime(data.startDate),
						endDate: getTime(data.endDate),
						isInfinite: data.isInfinite,
						isLink: data.isLink,
						linkType: data.linkType,
						linkValue: data.linkValue,
						s3Key: `${data.fileDir}/${data.fileSaveName}`.substr(1),
						sort: item.sort,
					};

					const res = await this.$axiosAdmin2.post(
						'/api/popup/save',
						params
					);

					if (res.data.resultCode === 'success') {
						alert('수정되었습니다.');
						this.getList(this.searchWord);
					}

					this.$store.commit('toggleSpinner', false);
				} catch (err) {
					alert('서버와 통신중 문제가 발생했습니다.');
					console.error(err);

					this.$store.commit('toggleSpinner', false);
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	#app-main DIV.popup {
		.popup__list__summary {
			font-weight: bold;
		}

		.popup__list__table__title {
			color: $btn-blue;
		}

		.popup__list__table__sort {
			width: 4em;
			height: 2em;
			text-align: center;
			border: 1px solid #dfe6ee;
			border-radius: 5px;
			padding: 0;
			margin-right: 5px;
		}

		.popup__list__table__sort-change {
			vertical-align: middle;
		}

		.popup__list__table__sort-change--disabled {
			background: gray;
			opacity: 0.5;
			cursor: not-allowed;
		}

		.popup__list__delete {
			border: 1px solid #f22c61;
			color: #f22c61;
			background: #fff;
			border-radius: 2px;
			padding: 0.3em 1em;
		}

		.popup__list__table--exp {
			background: #ffbcce;

			&:hover {
				background: #ffbcce;
			}
		}
	}
</style>
